import React from 'react';
import { Page, Text, View, Document, StyleSheet, Image } from '@react-pdf/renderer';

interface Props {
  mailStop: any;
  businessUnit: any;
  inventoryYear: any;
  propertyCoordinator: any;
  date: any;
  departmentName: any;
  missingItems: any;
}

export const OwnerLetter = (props: Props) => (
  <Document>
    <Page style={styles.body}>
      <View style={styles.row}>
        <Image style={styles.image} src={`${process.env.PUBLIC_URL}/countyLogo.jpg`} />
        <View style={styles.topRight}>
          <Text style={styles.rightAlign}>PURCHASING DIVISION</Text>
          <Text style={styles.rightAlign}>2660 Riva Road, 3rd Floor</Text>
          <Text style={styles.rightAlign}>Annapolis, MD 21401</Text>
          <Text style={styles.rightAlign}>MS-9302</Text>
          <Text style={styles.rightAlign}>(410) 222-7620 FAX (410) 222-7624</Text>
        </View>
      </View>
      <Text style={styles.title}>INTER-OFFICE MEMORANDUM</Text>
      <View style={styles.section}>
        <Text>DATE: {props.date}</Text>
      </View>
      <View style={styles.section}>
        <Text>TO: Surina Stillman, Property Control & Accountability Manager MS 4280</Text>
      </View>
      <View style={styles.section}>
        <Text>
          FROM: {props.propertyCoordinator}, Property Coordinator for {props.departmentName} Department{' '}
          {props.mailStop ? `MS ${props.mailStop}` : '(No mailstop available)'}
        </Text>
      </View>
      <View style={styles.section}>
        <Text>
          SUBJECT: Non-Capital Fixed Asset Inventory {props.inventoryYear} - Business Unit {props.businessUnit}
        </Text>
      </View>
      {props.missingItems.length === 0 && (
        <View style={styles.description}>
          <Text>
            This memorandum will certify that the Non-Capital Fixed Asset Inventory for {props.inventoryYear} for business
            unit(s) #{props.businessUnit}. Purchasing is accurate and up-to-date as of {props.date}. All inventory assets
            have been confirmed in this business unit. Our Non-Capital Fixed Asset Inventory has been updated in Enterprise
            One.
          </Text>
        </View>
      )}
      {props.missingItems.length > 0 && (
        <View>
          <View style={styles.description}>
            <Text>
              This memorandum will certify that the Non-Capital Fixed Asset Inventory for {props.inventoryYear} for business
              unit(s) #{props.businessUnit}. Purchasing is accurate and up-to-date as of {props.date}. One or more assets
              will be coded as missing. They include the following:
            </Text>
          </View>
          <View style={styles.missingItems}>
            {props.missingItems.map((missingItem: any, index: number) => {
              return (
                <Text key={index}>
                  {missingItem.BarCode} - {missingItem.Description}
                </Text>
              );
            })}
          </View>
        </View>
      )}
      <View style={styles.signatureSection}>
        <View style={styles.row}>
          <Text style={styles.depHeadField}>Department Head Signature/Designee</Text>
          <Text style={styles.dateField}>Date</Text>
        </View>
        <Text style={styles.titleField}>(Title)</Text>
      </View>
    </Page>
  </Document>
);

// Font.register({
//   family: "Times New Roman",
//   src: `${process.env.PUBLIC_URL}/fonts/TIMES.ttf`
// });

// Font.register({
//   family: "Times Bold",
//   src: `${process.env.PUBLIC_URL}/fonts/TIMESBD.ttf`
// });

const styles = StyleSheet.create({
  body: {
    paddingBottom: 65,
    paddingHorizontal: 35,
    //fontFamily: 'Times New Roman',
  },
  title: {
    fontSize: 18,
    textAlign: 'center',
    textDecoration: 'underline',
    marginVertical: 10,
    //fontFamily: 'Times Bold',
  },
  image: {
    textAlign: 'left',
    maxHeight: '70%',
    maxWidth: '70%',
    marginTop: 20,
  },
  section: {
    fontSize: 14,
    marginVertical: 10,
    marginHorizontal: 40,
    // fontFamily: 'Times Bold',
  },
  description: {
    fontSize: 12,
    marginHorizontal: 40,
  },
  rightAlign: {
    textAlign: 'right',
    fontSize: 13,
    marginVertical: 2,
  },
  topRight: {
    marginVertical: 20,
    marginRight: 180,
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
  },
  signatureSection: {
    marginTop: 70,
    border: '2px solid black',
    borderTopWidth: '2px',
    fontSize: 13,
    paddingHorizontal: 40,
  },
  depHeadField: {
    paddingTop: 3,
    paddingRight: 25,
    borderTopWidth: 1,
  },
  dateField: {
    marginLeft: 150,
    borderTopWidth: 1,
    paddingRight: 50,
    paddingTop: 3,
    marginRight: 180,
  },
  titleField: {
    marginTop: 40,
    paddingTop: 3,
    borderTopWidth: 1,
    marginRight: '60%',
  },
  missingItems: {
    fontSize: 15,
    marginTop: 22,
    marginHorizontal: 40,
  },
});
